import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import XIcon from './icons/XIcon';
import InteractiveComparisonViewer from './InteractiveComparisonViewer';

interface ClinicalLoupeProps {
    onClose: () => void;
    originalImageUrl: string;
    generatedImageUrl: string;
    initialAspectRatio: number | null;
}

const ClinicalLoupe: React.FC<ClinicalLoupeProps> = ({ onClose, originalImageUrl, generatedImageUrl, initialAspectRatio }) => {

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', handleKeyDown);
        document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'auto';
        };
    }, [onClose]);

    return (
        <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}
            className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-md flex items-center justify-center overflow-hidden"
            role="dialog"
            aria-modal="true"
            aria-label="Clinical Loupe View"
        >
            {/* Close Button */}
            <button
                onClick={onClose}
                className="absolute top-6 right-6 z-[110] p-2.5 text-white/70 hover:text-white rounded-full bg-white/5 hover:bg-white/10 backdrop-blur-md border border-white/10 transition-all hover:scale-105 focus:outline-none focus:ring-2 focus:ring-teal-500/50"
                aria-label="Close Loupe"
            >
                <XIcon className="w-6 h-6" />
            </button>

            {/* Main Viewer Area */}
            <div className="w-full h-full flex items-center justify-center p-4">
                <div className="w-full h-full max-w-[95vw] max-h-[90vh]">
                    <InteractiveComparisonViewer
                        beforeImageUrl={originalImageUrl}
                        afterImageUrl={generatedImageUrl}
                        initialAspectRatio={initialAspectRatio}
                        isFullscreen={true}
                    />
                </div>
            </div>
        </motion.div>
    );
};

export default ClinicalLoupe;
